import { SortKey } from '../../../../utils/tableHelper';

export const salesByProductReportColumns = {
  image: { label: 'Image', canBeHidden: true, isDefault: true },
  date: { label: 'Date', canBeSorted: true, isDefault: true },
  retailerId: {
    label: 'Sales channel',
    canBeHidden: true,
    isDefault: true,
  },
  model: { label: 'Model', canBeSorted: true, sortKey: SortKey.MODEL, isDefault: true },
  productName: {
    label: 'Product name',
    canBeHidden: true,
    canBeSorted: true,
    isDefault: true,
  },
  country: {
    label: 'Country',
    canBeHidden: true,
    isDefault: true,
  },
  ordersCount: {
    label: 'No. of orders',
    canBeHidden: true,
    canBeSorted: true,
    sortKey: SortKey.ORDERS_COUNT,
    isDefault: true,
  },
  unitsCount: {
    label: 'Ordered units',
    canBeHidden: true,
    canBeSorted: true,
    isDefault: true,
  },
  gmv: {
    label: 'Sales',
    canBeHidden: true,
    canBeSorted: true,
    isCurrency: true,
    isDefault: true,
  },
  returnedUnitsCount: {
    label: 'Returned units',
    canBeHidden: true,
    canBeSorted: true,
    isDefault: true,
  },
  returnedValue: {
    label: 'Refunds',
    canBeHidden: true,
    canBeSorted: true,
    isCurrency: true,
    isDefault: true,
  },
  returnRate: {
    label: 'Return rate',
    canBeHidden: true,
    isRatePercentage: true,
    isDefault: true,
  },
  cancelledUnitsCount: {
    label: 'Cancelled units',
    canBeHidden: true,
    canBeSorted: true,
    isDefault: true,
  },
  cancellationsValue: {
    label: 'Cancellation value',
    canBeHidden: true,
    canBeSorted: true,
    isCurrency: true,
    isDefault: true,
  },
  cancellationRate: {
    label: 'Cancellation rate',
    canBeHidden: true,
    isRatePercentage: true,
    isDefault: true,
  },
  netSales: {
    label: 'Net sales',
    canBeHidden: true,
    isCurrency: true,
    isDefault: true,
  },
  currency: {
    label: 'Currency',
    hidden: true,
  },
  orderType: {
    label: 'Order type',
    canBeHidden: true,
    canBeSorted: true,
  },
};
